// extracted by mini-css-extract-plugin
export default {"add":"yq36_rEtOOWM27z_YUkw"};